/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentRiskMatrix.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Risk Matrix API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, January 21, 2019 - 05:31:24 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const RiskMatrix = {
    all: () => requests.get('/RiskMatrixes'),
    get: riskmatrixid => requests.get(`/RiskMatrix/${riskmatrixid}`),
    create: riskmatrix => requests.post(`/RiskMatrixes`, riskmatrix),
    update: (riskmatrixid, riskmatrix) => requests.put(`/RiskMatrix/${riskmatrixid}`, riskmatrix),
    delete: riskmatrixid => requests.del(`/RiskMatrix/${riskmatrixid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentRiskMatrix.js